module.exports = __webpack_public_path__ + "img/sub_page_communication47.89a0617d.png";